import { makeAutoObservable, runInAction } from 'mobx';

import S3UploadAPI from '@/common/api/S3UploadAPI';
import useStore from '@/common/hooks/useStore';
import Notifier from '@/common/services/Notifier';

import { UploadFileApiVersion } from './UploadFileStore.types';

class UploadFileStore {
  isUploading = false;

  private s3UploadAPI: S3UploadAPI;

  constructor() {
    makeAutoObservable<UploadFileStore, 's3UploadAPI'>(this, {
      s3UploadAPI: false,
    });

    this.s3UploadAPI = new S3UploadAPI();
  }

  uploadImage = async (file: File, apiVersion: UploadFileApiVersion = 1) => {
    this.isUploading = true;

    try {
      const response =
        apiVersion === 2 ? await this.s3UploadAPI.uploadImageV2(file) : await this.s3UploadAPI.uploadImage(file);

      return response?.content;
    } catch (e) {
      Notifier.error(e);

      throw e;
    } finally {
      runInAction(() => {
        this.isUploading = false;
      });
    }

    return null;
  };
}

export const useUploadFileStore = () => useStore(UploadFileStore);

const uploadFileStore = new UploadFileStore();

export { UploadFileStore };
export default uploadFileStore;
